import { Area, AreaChart as AreaChartBase, CartesianGrid, Tooltip, XAxis, YAxis } from "recharts";
import { ChartContainer } from "../ui/chart";
import { cn } from "@/common/utils/cn";
import CustomChartTooltip from "../ui/chartTooltip";
import { chartTickFormatters } from "@/common/utils/chartTickFormatter";
import { ChartData } from "@/common/types/chart.type";

export interface AreaChartProps {
  chartData: ChartData;
  className?: string;
}

const AreaChart = ({ chartData, className }: AreaChartProps) => {
  return (
    <ChartContainer config={chartData.series_settings} className={cn('min-h-[200px] w-full', className)}>
      <AreaChartBase
        responsive
        width="100%"
        height="100%"
        data={chartData.data}
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        style={{ aspectRatio: 1.618 }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="10%" stopColor="#007BE594" stopOpacity={0.7} />
            <stop offset="90%" stopColor="#007BE594" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeWidth={0} fill="#ffffff1a" />
        <XAxis
          dataKey={chartData.primary?.query_identifier}
          fontWeight={700}
          tickMargin={8}
          tickLine={false}
          interval="preserveStartEnd"
        />
        <YAxis
          orientation="right"
          fontWeight={700}
          tickMargin={0}
          width={110}
          tickLine={false}
          tickFormatter={
            chartData.tick_settings?.y?.format_parser
              ? chartTickFormatters[chartData.tick_settings?.y?.format_parser as keyof typeof chartTickFormatters]
              : undefined
          }
        />
        <Tooltip
          content={(props) => (
            <CustomChartTooltip {...props} seriesSettings={chartData.series_settings} />
          )}
        />

        {Object.values(chartData.series_settings).map(({ query_identifier, color }) => (
          <Area
            type="linear"
            key={query_identifier}
            dataKey={query_identifier}
            strokeWidth={2.5}
            stroke={color}
            fillOpacity={1}
            fill="url(#colorUv)"
            animationDuration={750}
            isAnimationActive={true}
          />
        ))}
      </AreaChartBase>
    </ChartContainer>
  )
};

export default AreaChart;
